import React, { useRef, useState } from "react";
import { ChevronRightIcon } from '@heroicons/react/outline'
import { Link } from "react-router-dom";
import useHandleClickOutside from '../HandleClickOutside/HandleClickOutside';

const Accordion = ({ PagesGroupName, PageLinks, icon }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState("0px")
    const content = useRef(null);

    function handleToggleAccordion() {
        setIsOpen(isOpen => !isOpen);
        setHeight(isOpen ? "0" : `${content.current.scrollHeight}px`)

    };

    let domNode = useHandleClickOutside(() => {
        setHeight("0");
        setIsOpen("");

    })

    return (
        <div ref={domNode} className={`transition ${isOpen ? 'bg-black bg-opacity-10' : ''}`}>
            <span onClick={handleToggleAccordion} className={`links-sidenav justify-between ${isOpen ? 'bg-black bg-opacity-10 text-white' : ''}`}><span className="flex items-center">{icon}{PagesGroupName}</span> <ChevronRightIcon className={`h-4 w-4 mr-0 text-white transition-transform ${isOpen ? 'rotate-90' : ''}`} /></span>
            <div ref={content} style={{ maxHeight: `${height}` }} className={`flex flex-col overflow-hidden transition-all pl-11 ${isOpen ? 'opacity-100' : ' opacity-0'}`}>
                {PageLinks.map(({ key, path }, i) => (
                    <Link to={path} key={i} className="links-sidenav first:mt-3 last:mb-3">{key}</Link>
                ))}
            </div>
        </div>
    );
};

export default Accordion;



